<template>
  <table border='1' cellspacing='0' cellpadding='4'>
    <thead>
      <tr>
        <th class='print-logo' colspan='5'><img :src="logo"/></th>
        <th :colspan="maxOutcomesPerPage" v-html="t('PrintOdds.HeaderText')"></th>
      </tr>
      <tr>
        <th :colspan="maxOutcomesPerPage">{{sportName}}</th>
      </tr>
    </thead>
    <tbody>
      <template v-for="(row,ri) in tableRows">
        <tr :key="`header_${ri}`">
          <th :colspan="maxOutcomesPerPage" class='text-left'>{{row.name}}</th>
        </tr>
        <tr v-for="(chunk,ci) in row.chunkedOutcomes" :key="`outcome_${ri}_${ci}`">
          <td v-for="(outcome,oi) in chunk" :key="`o_${ci}_${oi}`">
            {{outcome.name}}
            <hr>
            {{outcome.outcome | formatOddDisplay}}
          </td>
          <td v-if="chunk.length < maxOutcomesPerPage" :colspan="maxOutcomesPerPage - chunk.length"></td>
        </tr>
      </template>
    </tbody>
  </table>
</template>
<script>
  export default {
    name: 'OutrightsPrintPage',
    props: {
      tableRows: {
        type: Array,
        required: true,
      },
      maxOutcomesPerPage: {
        type: Number,
        required: true,
      },
      sportName: {
        type: String,
        required: true,
      },
      logo: {
        type: HTMLImageElement,
        required: true,
      },
    }
  };
</script>